/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdAddressesCopyToPayment202,
  PostApiV1PersonIdAddressesCopyToPayment401,
  PostApiV1PersonIdAddressesCopyToPayment404,
  PostApiV1PersonIdAddressesCopyToPayment500,
  PostApiV1PersonIdAddressesCopyToPaymentMutationResponse,
  PostApiV1PersonIdAddressesCopyToPaymentPathParams,
} from "../../types/personRegisterController/PostApiV1PersonIdAddressesCopyToPayment.ts";
import { personAddressDetailViewModelSchema } from "../personAddressDetailViewModelSchema.ts";

export const postApiV1PersonIdAddressesCopyToPaymentPathParamsSchema = z.object(
  {
    id: z.coerce.number().int(),
  },
) as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPaymentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PersonIdAddressesCopyToPayment202Schema = z.lazy(
  () => personAddressDetailViewModelSchema,
) as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPayment202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdAddressesCopyToPayment401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPayment401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdAddressesCopyToPayment404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPayment404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdAddressesCopyToPayment500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPayment500>;

export const postApiV1PersonIdAddressesCopyToPaymentMutationResponseSchema =
  z.lazy(
    () => postApiV1PersonIdAddressesCopyToPayment202Schema,
  ) as unknown as ToZod<PostApiV1PersonIdAddressesCopyToPaymentMutationResponse>;
